import { render } from "./TourSearchView.vue?vue&type=template&id=0cc8c3d4"
import script from "./TourSearchView.vue?vue&type=script&lang=js"
export * from "./TourSearchView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__